import { useQuery, useMutation } from '@tanstack/react-query';

import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { accountUserDetailKey } from '../common/queryKeys';

export const useAccountUserCsInquiryDetailQuery = ({ userId, pagination, sortOption, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'csInquiry', 'detail', userId, pagination, sortOption, filterOption],
    async () => {
      const result = await AccountUserApi.getAccountUserCsInquiryDetail(
        setRequestForm({ userId, csInquiryHistory: { pagination, sortOption, filterOption } }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      placeholderData: { data: { csInquiryList: { list: [], totalCnt: 0 } } },
    },
  );
};

export const useAccountUserDetailCsInquiryListExcelDownloadMutate = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const result = await AccountUserApi.getAccountUserDetailCsInquiryListExcelDownload(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
  });
};
